var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-text-button",class:{ active: _vm.active },on:{"click":_vm.onClick}},[_c('InlineSvg',{staticClass:"svg-text-button__icon",attrs:{"src":_vm.src}}),_c('span',{staticClass:"svg-text-button__text",class:[`fs-${_vm.fontSize}` , { 'font-weight-bold': _vm.bold }]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }